import { FC, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { DeleteCollectionsModal } from "@/components/modal/delete-collections";
import { CollectionsListPageList } from "@/pages/collections/components/collections-list-page-list";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import { MDSFadeBottom } from "@/mds";
import { ShareSheetModal } from "@/components/modal/share-sheet/share-sheet-modal";
import { MDSPanelContainer } from "@/mds";
import { TrackedEvent } from "@/domains/metrics";
import { trackEvent } from "@/domains/metrics";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";
import { useTabParams } from "@/components/layout/components/tab-bar/use-tab-params";

interface Props {}

export const ImportedCollectionsListPage: FC<Props> = observer(() => {
  const { importBatchId } = useTabParams();
  const page = useTabPageStore("collectionsListPage");

  useEffectOnMount(() => {
    page.resetState();
  });

  /**
   * Track views of the collections list page.
   */
  useEffect(() => {
    trackEvent(TrackedEvent.ImportedCollectionsView, {
      lens: page.lens,
      sort_by: page.sortBy,
      import_batch_id: importBatchId,
    });
  }, [page.lens, page.sortBy, importBatchId]);

  return (
    <>
      <ShareSheetModal store={page.shareSheetModal} />
      <DeleteCollectionsModal state={page.deleteCollectionModal} />
      <MDSPanelContainer>
        {!page.isLoading && <CollectionsListPageList />}
        <MDSFadeBottom />
      </MDSPanelContainer>
    </>
  );
});
